import React, { useEffect, useState } from 'react'
import { Alert, Button, Spin, Tooltip } from 'antd'
import { supplyRequest } from './api'

export default function DeliveryTotals({ month, date, search, supplier, selectedKeys, revision }: {
  month: string; date: string; search: string; supplier: string; selectedKeys: string[]; revision: string
}) {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [retry, setRetry] = useState(0)
  const keys = [...selectedKeys].sort().join(',')
  useEffect(() => {
    let active = true
    setLoading(true); setData(null); setError('')
    const query = new URLSearchParams({ month, date, search, ...(supplier ? { supplier } : {}), ...(keys ? { keys } : {}) })
    supplyRequest(`/api/supply/delivery-totals?${query}`, { timeoutMs: 180000 }).then(result => {
      if (result.data?.complete !== true) throw new Error('Не удалось рассчитать полный итог')
      if (active) setData(result.data)
    }).catch(cause => { if (active) setError(cause.message) }).finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [month, date, search, supplier, keys, revision, retry])
  const metric = (label: string, value: any, suffix = '') => <Tooltip key={label} title={value?.missing ? `Нет данных для ${value.missing} позиций. Показана только известная часть.` : undefined}>
    <span className={value?.missing ? 'delivery-calendar__metric-incomplete' : ''}>{label}: <strong>{value?.value == null ? '—' : value.value.toLocaleString('ru-RU', { maximumFractionDigits: 2 })}{suffix}</strong>{value?.missing && value?.value != null ? ' · частично' : ''}</span>
  </Tooltip>
  return <div className="delivery-calendar__totals" aria-live="polite">
    <strong>{keys ? `Выбрано: ${selectedKeys.length}` : search || supplier ? 'Итого по фильтру' : 'Итого за день'}</strong>
    {loading ? <span><Spin size="small" /> Считаем итоги…</span> : error ? <Alert type="warning" message={error} action={<Button size="small" onClick={() => setRetry(value => value + 1)}>Повторить</Button>} /> : data && <>
      <span>Поставок: <strong>{data.deliveries}</strong></span><span>Позиций: <strong>{data.positions}</strong></span>
      {data.amounts.map((amount: any, index: number) => metric('Сумма' + (data.amounts.length > 1 ? ` ${index + 1}` : ''), amount, amount.currency ? ` ${amount.currency}` : ''))}
      {metric('Вес, кг', data.weight)}{metric('Площадь, м²', data.area)}
    </>}
  </div>
}
